const formatReturn = (ret) => {
    ret = (ret*100).toFixed(1);
    if (ret>0) {
        ret = '+' + ret;
    }
    return ret+'%';
};

export default formatReturn;
